module.exports = __webpack_public_path__ + "img/newstop_bg.3ec6a32a.jpg";